
import { useState } from 'react';

export default function NewsletterSection() {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState<'idle' | 'submitting' | 'success' | 'error'>('idle');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setStatus('submitting');

    try {
      const formBody = new URLSearchParams();
      formBody.append('email', email);

      const response = await fetch('https://readdy.ai/api/public/form/submit/newsletter-learn-best-building', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: formBody.toString()
      });

      if (response.ok) {
        setStatus('success');
        setEmail('');
        setTimeout(() => setStatus('idle'), 5000);
      } else {
        setStatus('error');
        setTimeout(() => setStatus('idle'), 5000);
      }
    } catch (error) {
      setStatus('error');
      setTimeout(() => setStatus('idle'), 5000);
    }
  };

  return (
    <section className="py-16 md:py-24 px-4 md:px-8 bg-[#1A1A1A] text-white">
      <div className="max-w-4xl mx-auto text-center">
        <h2 className="text-3xl md:text-4xl font-bold mb-4" style={{ fontFamily: 'Montserrat, sans-serif' }}>
          Get New Video Guides Straight to Your Inbox
        </h2>
        <p className="text-lg text-gray-300 mb-8">
          Be the first to know when we release new tutorials, tips, and product guides.
        </p>

        <form id="newsletter-learn-best-building" data-readdy-form onSubmit={handleSubmit} className="flex flex-col sm:flex-row gap-4 max-w-2xl mx-auto">
          <input
            type="email"
            name="email"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Enter your email address"
            className="flex-1 px-6 py-4 rounded-lg text-gray-900 focus:ring-2 focus:ring-[#F2C612] outline-none"
          />
          <button
            type="submit"
            disabled={status === 'submitting'}
            className="w-full sm:w-auto min-h-[44px] bg-[#F2C612] text-[#1A1A1A] px-8 py-4 rounded-lg font-semibold hover:bg-[#d4ad0a] transition-colors disabled:opacity-50 disabled:cursor-not-allowed whitespace-nowrap cursor-pointer"
            style={{ fontFamily: 'Montserrat, sans-serif' }}
          >
            {status === 'submitting' ? 'Subscribing...' : 'Subscribe'}
          </button>
        </form>

        {status === 'success' && (
          <p className="mt-4 text-green-400">Thanks for subscribing! Check your inbox for confirmation.</p>
        )}

        {status === 'error' && (
          <p className="mt-4 text-red-400">Something went wrong. Please try again.</p>
        )}
      </div>
    </section>
  );
}